



















import { Component, Vue } from 'vue-property-decorator';
import router from '../router';


@Component({
  components: {
  }
})

export default class QR extends Vue {
public toggleRead() {
    const text = document.getElementById('more');
    const dots = document.getElementById('dots');

    if (text && dots){
        if (text.classList.contains('show')){
            text.classList.remove('show');
            dots.classList.remove('hide');
        } else {
            text.classList.add('show');
            dots.classList.add('hide');
        }
    }
}

mounted() {
    const app = document.getElementById('app');

    if (app){
        app.classList.add('qr-bg');
    }
}
    
}



